module.exports = __webpack_public_path__ + "img/zbBg.653fadcf.png";